// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19d239af","987":"f15ab420"}[chunkId] + ".chunk.js";
};